import {request, serviceUrl} from "@/utils/request";

//获取告警级别
export function getLevelList() {
    return request({
        url: serviceUrl.deviceService + '/alarm/level/list'
    })
}

//编辑告警级别
export function updateLevel(id=null,level,levelName,levelColor) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/alarm/level/update',
        data:{
          id,level,levelName,levelColor
        }
    })
}

//新增告警级别
export function saveLevel(id=null,level,levelName,levelColor) {
    return request({
        method: 'post',
        url: serviceUrl.deviceService + '/alarm/level/save',
        data:{id,level,levelName,levelColor}
    })
}

// 分页获取告警级别
export function getLevelPage(params) {
    return request({
        url: serviceUrl.deviceService + '/alarm/level/page',
        params: params
    })
}

// 删除告警配置
export function deleteLevel(levelId) {
    return request({
        method: 'DELETE',
        url: serviceUrl.deviceService + '/alarm/level/deleteLevel',
        params: {levelId}
    })
}
